import { mapItemDetails } from 'tradera-state/views/view-item/reducer';

var initialState = {
    itemDetails: null,
    bidInfo: null,
    hasLoaded: false,

    viewItemState: null,
    isBidding: false,
    itemState: null,
    placeBidResponse: {
        info: null,
        isSuccessful: null,
        validationResult: null,
        error: null
    },
    myMaxBidAmount: null,
    initialBidFormValue: null,
    serverSecondsLeft: null
};

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_PREVIEW_ITEM_DETAILS': {
            return {
                ...state,
                itemDetails: mapItemDetails(action.payload)
            };
        }
        case 'SET_PREVIEW_BID_INFO': {
            const { bidInfo, memberId } = action.payload;

            return {
                ...state,
                bidInfo: {
                    bidId: bidInfo.bidId || 0,
                    leadingBidAmount: bidInfo.leadingBidAmount || 0,
                    leadingBidderMemberId:
                        bidInfo.leadingBidderMemberId || null,
                    leadingBidMemberAlias:
                        bidInfo.leadingBidMemberAlias || null,
                    nextValidBidAmount: bidInfo.nextValidBidAmount,
                    transactionType: bidInfo.transactionType || null,
                    bidCount: bidInfo.bidCount,
                    reservePriceReached: bidInfo.reservePriceReached || false,
                    hasLeadingBid:
                        !!memberId &&
                        memberId === bidInfo.leadingBidderMemberId,
                    hasLostLeadingBid: false
                }
            };
        }
        case 'SET_PREVIEW_ITEM_STATE':
            return { ...state, itemState: action.payload };
        case 'SET_PREVIEW_SERVER_SECONDS_LEFT':
            return { ...state, serverSecondsLeft: action.payload };
        case 'SET_PREVIEW_IS_LOADING':
            return { ...state, hasLoaded: action.payload };
        default:
            return state;
    }
};
